// Tenant Domains
// sd.lineaetica.com.mx
// larrabezua.sistemaetico.com
// ethicsglobal.com
// demo.v2.ethicsglobal.com

export const getTenant = () =>  {
    const tenantLs = localStorage.getItem("origin_domain");
    // if(!tenantLs) return null;
    // const tenant = JSON.parse(tenantLs);
    // if(!tenant) return null;

    //const nombreDominio = window.location.hostname;

    return tenantLs;
}